<header [ngClass]="{'background-darker' : !user && !showDefaultColor, 'logged-header-color' : user || showDefaultColor}">
    @if (!createCategorySection && !courseCategorySection) {
        <div class="container" [ngClass]="{'no-border size': !user && hasPermission(PermissionsEnum.MARKETPLACE)}">
            <div class="logo-container" [ngClass]="{ 'gap-24': !user && hasPermission(PermissionsEnum.MARKETPLACE) }">
				<button class="show-sidebar" mat-icon-button (click)="showSidebar()">
                    <mat-icon svgIcon="three_lines"></mat-icon>
                </button>
                <img class="logo pointer" src="{{headerLogo}}" alt="logo" (click)="redirectToUserDefaultPage()">
                @if (!user && hasPermission(PermissionsEnum.MARKETPLACE)) {
                    <div class="flex center column-gap-32">
                        <button mat-button class="pointer btn-view text-accent-lighter" (click)="redirectToUserDefaultPage()"><p>{{'header.home' | translateWithKeys}}</p></button>
                        <button mat-button class="pointer btn-view text-accent-lighter no-wrap"><p>{{'header.about_us' | translateWithKeys}}</p></button>
                    </div>
                }
            </div>
            @if (!user && hasPermission(PermissionsEnum.MARKETPLACE)) {
                <div class="flex row center column-gap-16">

                    <div class="flex row center user-name-container" *hasPermission="PermissionsEnum.VIEW_SHOPPING_CART">
						<p class="cart-count" (click)="goToCart()" >{{ categoriesCount$ | async }}</p>
						<button (click)="goToCart()" mat-icon-button >
							<mat-icon class="mr-32" svgIcon="shopping_cart"></mat-icon>
						</button>
					</div>

                    @if (!isSmallScreen) {
                        <button mat-stroked-button (click)="redirectTo(routeEnum.LOGIN)" class="text-accent-lighter primary-btn">
                            <p class="btn-view title2">{{'header.login' | translateWithKeys}}</p>
                        </button>
                    }
                </div>
            } @else {
                <div class="flex row center user-name-container">
					<div class="flex row center cart-container" *hasPermission="PermissionsEnum.VIEW_SHOPPING_CART">
						<p class="cart-count" (click)="goToCart()" >{{ categoriesCount$ | async }}</p>
						<button (click)="goToCart()" mat-icon-button >
							<mat-icon class="cart" svgIcon="cart"></mat-icon>
						</button>
					</div>
                    @if (user) {
                        <div class="flex row column-gap-16 vertical-center">
						@if (!isSmallScreen) {
                            <div class="position-language" *hasPermission="PermissionsEnum.LANGUAGE_SWITCHER_ON_HEADER">
                                <app-language-switcher [textColorWhite]="true" [hoverDisabled]="true"></app-language-switcher>
                            </div>
							<ng-container *hasPermission="PermissionsEnum.VIEW_TAWKTO_SUPPORT">
								<app-chat [smallScreen]="isSmallScreen" ></app-chat>
							</ng-container>
						} @else {
							<div class="position-language" *hasPermission="PermissionsEnum.LANGUAGE_SWITCHER_ON_HEADER">
                                <app-language-switcher [textColorWhite]="true" [hoverDisabled]="true"></app-language-switcher>
                            </div>
						}
                            <div class="separator"></div>
                            <div [matMenuTriggerFor]="userMenu" class="flex column pointer vertical-center baseline" (click)="closeSidebar()">
                                <div class="flex row gap-8 vertical-center">
                                    <p class="logged-text-color"><b>{{user?.name}}</b></p>
                                    <mat-icon class="btn drop-icon" svgIcon="drop_icon">
                                    </mat-icon>
                                </div>
                                @if(user?.client){
                                    <p *hasPermission="PermissionsEnum.VIEW_HEADER_CLIENT_NAME" class="logged-text-color">{{user?.client}}</p>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (createCategorySection && !courseCategorySection) {
        <div class="create-category-container">
            <div class="btn-container">
                <button mat-button class="text-background-lighter" (click)="redirectToHome(routeEnum.CATEGORIES)">
                    <mat-icon svgIcon="arrow_left" class="back-btn"></mat-icon>
                    {{'general.back' | translateWithKeys}}
                </button>
            </div>
            <div>
                @if (!categoryOrCourseData) {
                    <p>{{'category-creation.new_category' | translateWithKeys}}</p>
                } @else {
                    <div class="flex gap-16">
                        <p>{{categoryOrCourseData?.name}}</p>
						@if (categoryOrCourseData?.id) {
							<p class="body1 pointer" (click)="copyId($event, categoryOrCourseData?.id)">{{'ID' + ' ' + categoryOrCourseData?.id}}</p>
							<mat-icon svgIcon="copy" [matTooltip]="'general.copy_to_clipboard' | translateWithKeys" class="copy-id-icon"></mat-icon>
						}
                    </div>
                }
            </div>
        </div>
    }

    @if (courseCategorySection && !createCategorySection) {
        <div class="create-category-container">
            <div class="btn-container">
                <button mat-button  class="text-background-lighter" (click)="redirectToHome(routeEnum.COURSE)">
                    <mat-icon svgIcon="arrow_left" class="back-btn"></mat-icon>
                    {{'general.back' | translateWithKeys}}
                </button>
            </div>
            <div class="flex column-gap-10">
                @if(categoryName?.length) {
                    <div class="pointer flex center column-gap-10" (click)="redirectToHome(routeEnum.CATEGORY_CREATION)">
                        <p>{{categoryName}}</p>
                        <mat-icon svgIcon="arrow_right" class="back-btn"></mat-icon>
                    </div>
                }
				@if (!categoryOrCourseData) {
                <p>{{'course-creation.new_course' | translateWithKeys}}</p>
				}@else {
                    <div class="flex gap-16">
                        <p>{{categoryOrCourseData?.name}}</p>
						@if (categoryOrCourseData?.id) {
							<p class="body1 pointer" (click)="copyId($event, categoryOrCourseData?.id)">{{'ID' + ' ' + categoryOrCourseData?.id}}</p>
							<mat-icon svgIcon="copy" [matTooltip]="'general.copy_to_clipboard' | translateWithKeys" class="copy-id-icon"></mat-icon>
						}
                    </div>
                }
            </div>
        </div>
    }

</header>
<mat-menu name="language" ngDefaultControl #menu="matMenu" [(ngModel)]="getLanguageService.currentLanguage">
	@for(language of availableLanguages; track $index){
		<button mat-menu-item (click)="changeLanguage(language)">{{'language-translations.'+language | translateWithKeys}}</button>
	}
</mat-menu>

<mat-menu name="language" ngDefaultControl #userMenu="matMenu">
	<div class="flex column userMenu">
		<button mat-menu-item class="text-accent-darker" (click)="goToSettings()" *hasPermission="[PermissionsEnum.VIEW_ACCOUNT_SETTINGS]">
            <span class="body2">
                {{'general.settings' | translateWithKeys}}
            </span>
        </button>
		<!-- TODO: remove component modal and route later -->
        <!-- <button mat-menu-item class="text-accent-darker" (click)="changePassword()">
            <mat-icon svgIcon="padlock"></mat-icon>
            <span class="body2">
                {{'general.change_password' | translateWithKeys}}
            </span>
        </button> -->
        <button *hasPermission="PermissionsEnum.LANGUAGE_SWITCHER_ON_USER_OPTIONS" mat-menu-item [mat-menu-trigger-for]="languagesMenu">
			<span class="body2">{{ 'general.language' | translateWithKeys }}</span>
		</button>
		<button mat-menu-item data-value="en" class="text-accent-darker" (click)="logout()">
			<mat-icon svgIcon="logout"></mat-icon>
			<span class="body2">
				{{'general.logout' | translateWithKeys}}
			</span>
		</button>
	</div>
</mat-menu>

<mat-menu #languagesMenu="matMenu" class="language-menu-style">
	@for (language of availableLanguages; track $index) {
		<button mat-menu-item (click)="changeLanguage(language)">{{ "language-translations."+language | translateWithKeys }}</button>
	}
</mat-menu>
